import React from "react";
const Dashboard = () => {
  return (
    <div className="p-2">
       Welcome to EAS
    </div>
  );
};

export default Dashboard;
